export enum InactiveOption {
  NOTIFY_PARENT_OF_INACTIVE = 1,
  NO_EMAIL_INACTIVE = 2,
}
